<template>
  <Menu as="div" class="relative">
    <MenuButton
        class="focus:outline-none flex items-center"
        @click="handleShow"
    >
        <BellAlertIcon
            class="text-won-green size-6"
            v-if="hasUnreadNotifications"
        />

        <BellIcon
            class="text-won-green size-6"
            v-else
        />
    </MenuButton>

    <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
    >
        <MenuItems
            class="absolute right-0 z-10 mt-2 origin-top-right rounded-lg bg-white shadow-xl focus:outline-none"
            :class="[{'w-[430px]': notifications.length, 'w-[217px]': !notifications.length}]"
        >
            <div
                v-if="notifications.length > 0"
                class="p-4"
            >
                <ul role="list" class="list-none">
                    <li v-for="(event, eventIdx) in notifications" :key="event.id">
                        <div :class="[{'pb-4': eventIdx + 1 < notifications.length}, 'relative']">
                            <div class="relative flex items-center space-x-3">
                                <div :class="['h-4 w-4 rounded-full flex items-center justify-center']">
                                    <span v-if="event?.icon" v-html="event?.icon"></span>
                                    <img src="/img/logo-won-white.png" class="w-[18px]" />
                                </div>
                                <div class="min-w-0 flex-1 flex justify-between space-x-4">
                                    <div>
                                        <p class="text-sm font-[Inter] font-normal text-[#073B5D]"  v-html="event.data.message" />
                                        <a
                                            v-if="event.data.link"
                                            :href="event.data.link"
                                            class="text-sm font-[Inter] font-normal text-won-blue-light"
                                        >
                                            Click here to see it
                                        </a>
                                    </div>
                                    <div class="text-right text-sm whitespace-nowrap font-[Inter] font-normal text-[#073B5D]">
                                        {{ moment(event.created_at, 'YYYY-MM-DD').format('MMM DD') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else class="flex p-2 items-center justify-center">
                <BellSnoozeIcon
                    class="size-6 text-won-green mr-1"
                />
        
                <p class="font-[Inter] text-sm font-medium text-[#073B5D] text-center">
                    No new notifications
                </p>
            </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import moment from 'moment';

import { getNotifictions, markNotificationsAsRead } from '../api/notifications'

import { Menu, MenuButton, MenuItems } from '@headlessui/vue'

import { BellAlertIcon, BellIcon, BellSnoozeIcon } from "@heroicons/vue/24/outline"

const notifications = ref([])
const hasUnreadNotifications = ref(false)
const route = useRoute()

const handleShow = async() => {
  await markNotificationsAsRead()

  setTimeout(() => {
    hasUnreadNotifications.value = false
  }, 1500)
}

onMounted(async() => {
    notifications.value = await getNotifictions()
    hasUnreadNotifications.value = notifications.value.filter(el => !el.read_at).length
})
</script>
